// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m-Yu","newExpiryDate":"styles_newExpiryDate__3JvBO","footer":"styles_footer__1PYqM"};